import React from 'react';
import { Box } from '@mui/material';

/**
 * Barion „Smart Payment Banner” — a hivatalos logósor (Barion, Mastercard, Visa, Apple Pay, Google Pay).
 * A Barion-elfogadóhely feltétele, hogy a főoldalon és a fizetési oldalon VÁLTOZTATÁS NÉLKÜL megjelenjen
 * (Barion Smart Payment Banner Developer Guidelines, 2025-10):
 * - világos változat világos, sötét változat sötét háttérre;
 * - a fizetésnél a fizetési mód közelében, görgetés nélkül látható helyen;
 * - nem nyújtható, vágható, árnyékolható; legalább 8px térköz körülötte;
 * - kisebb képernyőn kisebb méret.
 * A fájlok a hivatalos csomagból: public/images/barion/barion-smart-banner-{light,dark}.svg
 *
 * variant: 'light' (világos háttér, pl. fizetési ablak) | 'dark' (sötét háttér, pl. lábléc)
 * height: px vagy MUI breakpoint-objektum, pl. { xs: 28, sm: 36 }
 */
const BANNER_SRC = {
  light: '/images/barion/barion-smart-banner-light.svg',
  dark: '/images/barion/barion-smart-banner-dark.svg',
};

const BarionLogoStrip = ({ variant = 'light', height = { xs: 30, sm: 38 }, sx }) => (
  <Box
    component="img"
    src={BANNER_SRC[variant] || BANNER_SRC.light}
    alt="Biztonságos online fizetés a Barionnal — Mastercard, Visa, Apple Pay, Google Pay"
    sx={{ height, width: 'auto', maxWidth: '100%', display: 'block', m: '8px', ...sx }}
  />
);

export default BarionLogoStrip;
